import React from "react"

import AvatarMembershipStore from "@components/modals/AvatarMembership/EditModal/avatar-membership.store"

export const AvatarMembershipContext =
  React.createContext<AvatarMembershipStore | null>(null)

export default AvatarMembershipContext
